import React from "react";
import {Badge} from "peggirkit";
import {FormattedMessage} from "react-intl";
import {JobApplicationStatus} from "@/data/entities/jobApplication";
import {BadgeColorScheme} from "peggirkit/dist/components/Badge/BadgeElements/BadgeStyles";

type DisplayMap = {
    [key in JobApplicationStatus]: {
        color: BadgeColorScheme,
        msgId: string,
    };
};

export const displayMap: DisplayMap = {
    OPEN: {
        color: "success",
        msgId: "statusOpen",
    },
    IN_PROGRESS: {
        color: "warning",
        msgId: "statusInProgress",
    },
    CLOSED: {
        color: "danger",
        msgId: "statusClosed",
    },
};

type Props = {
    status: JobApplicationStatus,
};

const JobApplicationStatusFormatter = ({status}: Props) => {
    const {color, msgId} = displayMap[status];
    return (
        <Badge color={color}>
            <FormattedMessage id={msgId}/>
        </Badge>
    );
};

export default JobApplicationStatusFormatter;